/* eslint-disable max-len */
import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { TransportOperatorsTypes, TransportOperatorInterface } from './types';

// List Transport Operators
export const listTransportOperatorsRequest = (payload: object) =>
  action(TransportOperatorsTypes.LIST_TRANSPORT_OPERATORS_REQUEST, payload);
export const listTransportOperatorsSuccess = (payload: {
  transportOperatorsList: TransportOperatorInterface[];
}) => action(TransportOperatorsTypes.LIST_TRANSPORT_OPERATORS_SUCCESS, payload);
export const listTransportOperatorsFailure = () =>
  action(TransportOperatorsTypes.LIST_TRANSPORT_OPERATORS_FAILURE);

// Select Transport Operator
export const selectTransportOperatorRequest = (payload: {
  transportOperatorSelected: TransportOperatorInterface;
  refresh?: boolean;
  redirectTo?: string;
}) =>
  action(TransportOperatorsTypes.SELECT_TRANSPORT_OPERATOR_REQUEST, payload);
export const selectTransportOperatorSuccess = (payload: {
  transportOperatorSelected: TransportOperatorInterface;
}) =>
  action(TransportOperatorsTypes.SELECT_TRANSPORT_OPERATOR_SUCCESS, payload);
export const selectTransportOperatorFailure = () =>
  action(TransportOperatorsTypes.SELECT_TRANSPORT_OPERATOR_FAILURE);

// Update Transport Operator
export const updateTransportOperatorRequest = (payload: object) =>
  action(TransportOperatorsTypes.UPDATE_TRANSPORT_OPERATOR_REQUEST, payload);
export const updateTransportOperatorSuccess = (payload: {
  transportOperatorsList: TransportOperatorInterface[];
  transportOperatorSelected: TransportOperatorInterface;
}) =>
  action(TransportOperatorsTypes.UPDATE_TRANSPORT_OPERATOR_SUCCESS, payload);
export const updateTransportOperatorFailure = () =>
  action(TransportOperatorsTypes.UPDATE_TRANSPORT_OPERATOR_FAILURE);

// Request Access Transport Operator
export const operatorAccessRequest = (payload: { id: any }) =>
  action(TransportOperatorsTypes.OPERATOR_ACCESS_REQUEST, payload);

export const operatorAccessSuccess = () =>
  action(TransportOperatorsTypes.OPERATOR_ACCESS_SUCCESS);

export const operatorAccessFailure = () =>
  action(TransportOperatorsTypes.OPERATOR_ACCESS_FAILURE);
